// extracted by mini-css-extract-plugin
export const offer = "OfferHighlightCard-module--offer--1_OH4";
export const backgroundNeutral05 = "OfferHighlightCard-module--background-neutral05--2Hb1C";
export const backgroundWhite = "OfferHighlightCard-module--background-white--GXp4j";
export const icon = "OfferHighlightCard-module--icon--i7lVg";
export const title = "OfferHighlightCard-module--title--GAFwt";
export const content = "OfferHighlightCard-module--content--NP3U8";